// src/views/Dashboard/reporteAutomatico.js
// Apoyo del PDF automático (análisis en segundo plano): el worker del
// servidor abre el Dashboard en un Chrome sin pantalla y espera a que todo
// termine de cargar, igual que si el usuario estuviera mirando.

// Cuenta las peticiones HTTP en curso de la página (axios usa XHR). El
// socket se excluye: su long-polling siempre tiene una abierta.
export const instalarContadorDeRed = () => {
    if (window.__oddisRed) return window.__oddisRed;
    const estado = { enCurso: 0, ultimoCambio: Date.now() };
    const marcar = (delta) => {
        estado.enCurso = Math.max(0, estado.enCurso + delta);
        estado.ultimoCambio = Date.now();
    };
    const esSocket = (url) => String(url || '').includes('/socket.io/');

    const fetchOriginal = window.fetch.bind(window);
    window.fetch = (input, init) => {
        const url = typeof input === 'string' ? input : input?.url;
        if (esSocket(url)) return fetchOriginal(input, init);
        marcar(1);
        return fetchOriginal(input, init).finally(() => marcar(-1));
    };

    const openOriginal = XMLHttpRequest.prototype.open;
    const sendOriginal = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.open = function open(method, url, ...rest) {
        this.__oddisUrl = url;
        return openOriginal.call(this, method, url, ...rest);
    };
    XMLHttpRequest.prototype.send = function send(...args) {
        if (!esSocket(this.__oddisUrl)) {
            marcar(1);
            this.addEventListener('loadend', () => marcar(-1), { once: true });
        }
        return sendOriginal.apply(this, args);
    };

    window.__oddisRed = estado;
    return estado;
};

const esperar = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

export const esperarRedQuieta = async ({ quietoMs = 4000, limiteMs = 120000 } = {}) => {
    const red = window.__oddisRed;
    if (!red) return;
    const limite = Date.now() + limiteMs;
    while (Date.now() < limite) {
        if (red.enCurso === 0 && Date.now() - red.ultimoCambio >= quietoMs) return;
        // eslint-disable-next-line no-await-in-loop
        await esperar(250);
    }
};

// Estado que lee el worker desde Puppeteer (window.__oddisReporte).
export const reportarEstado = (estado, extra = {}) => {
    window.__oddisReporte = { estado, ...extra, fecha: Date.now() };
    // eslint-disable-next-line no-console
    console.log('[REPORTE_AUTO]', estado, extra?.mensaje || '');
};

// ¿Hay capas del análisis con datos en el mapa? (fuentes GeoJSON que no son
// los lotes, con features o con una URL remota ya asignada).
export const mapaTieneAnalisis = (map) => {
    try {
        const style = map?.getStyle?.();
        if (!style?.sources) return false;
        return Object.entries(style.sources).some(([id, source]) => {
            if (source?.type !== 'geojson') return false;
            if (id.includes('lote') || id === 'polygons-data') return false;
            const data = map.getSource(id)?.serialize?.()?.data ?? source.data;
            if (typeof data === 'string') return data.length > 0;
            return Array.isArray(data?.features) ? data.features.length > 0 : Boolean(data?.geometry);
        });
    } catch {
        return false;
    }
};

const TOKEN_KEY = 'oddis_reporte_render';

export const guardarTokenReporte = (jobId, token) => {
    try {
        sessionStorage.setItem(TOKEN_KEY, JSON.stringify({ jobId, token }));
    } catch {
        // sin sessionStorage el render no puede seguir
    }
};

export const leerTokenReporte = (jobId) => {
    try {
        const data = JSON.parse(sessionStorage.getItem(TOKEN_KEY) || 'null');
        return data && String(data.jobId) === String(jobId) ? data.token : null;
    } catch {
        return null;
    }
};
